import { useState, useEffect } from "react";


const useDeviceType = () => {
  // Initialize state based on the window width
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false; // Assume desktop for SSR
    return window.innerWidth <= 768;
  });

  useEffect(() => {
    // Avoid errors if window is not available
    if (typeof window === "undefined") return;

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768 || window.innerHeight <= 768);
    };

    // Add event listener to monitor window resizing
    window.addEventListener("resize", handleResize);

    // Cleanup event listener when the component unmounts
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
};

export default useDeviceType;
